module.exports = __webpack_public_path__ + "static/media/insight_desc4.dc2f6489.png";